import { render, staticRenderFns } from "./ContentSelector.vue?vue&type=template&id=5cbdadf0&scoped=true"
import script from "./ContentSelector.vue?vue&type=script&lang=js"
export * from "./ContentSelector.vue?vue&type=script&lang=js"
import style0 from "./ContentSelector.vue?vue&type=style&index=0&id=5cbdadf0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbdadf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbdadf0')) {
      api.createRecord('5cbdadf0', component.options)
    } else {
      api.reload('5cbdadf0', component.options)
    }
    module.hot.accept("./ContentSelector.vue?vue&type=template&id=5cbdadf0&scoped=true", function () {
      api.rerender('5cbdadf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/ContentSelector.vue"
export default component.exports